<template>
  <div class="cards__list">
    <div v-for="recipe in recipesList" :key="recipe.name" class="card">
      <div class="img">
        <img :src="recipe.data.image" alt="">
      </div>

      <div class="card__content">
        <h3>{{recipe.name}}</h3>
        <p>
          {{recipe.data.calories}} {{ $t("profile.home.recipeStats") }} / {{recipe.data.time}}
        </p>

        <div class="card__action" @click="() => selectRecipe(recipe)">
          {{ $t("profile.home.viewRecipe") }}
        </div>
      </div>
    </div>

    <modal-component @close="closeRecipeView" @changeModal="modal = $event" :modal="modal" :recipe="viewRecipe" />
  </div>
</template>

<script>
import recipesData from "./data/recipes.en.json";

export default {
  name: "day-recipes",

  props: ["date"],

  data() {
    return {
      viewRecipe: null,
      modal: null,
      week: 0,
      recipesList: [],
      currentDate: new Date(this.date),
      recipes: recipesData,
    };
  },

  async created() {
    try {
      const localeData = await import(`../components/data/recipes.${this.$i18n.locale}.json`);
      this.recipes = localeData.default;
    } catch (e) {
      console.log(e);
    }
    this.recipesList = this.getRecipesList();
  },

  watch: {
    date(value) {
      this.currentDate = new Date(value);
      this.recipesList = this.getRecipesList();
    },
  },

  methods: {
    getRecipesList() {
      const day = this.currentDate.getDay();
      const recipesOfDay = this.recipes[day];
      this.week = this.getWeekNumber(this.currentDate) % 2;

      return [
        {
          name: this.$t("profile.recipes.breakfast"),
          data: recipesOfDay.breakfast[this.week],
        },
        {
          name: this.$t("profile.recipes.lunch"),
          data: recipesOfDay.lunch[this.week],
        },
        {
          name: this.$t("profile.recipes.dinner"),
          data: recipesOfDay.dinner[this.week],
        },
      ];
    },
    getWeekNumber(d) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    },
    selectRecipe(recipe) {
      if (this.viewRecipe !== null && recipe.data.title === this.viewRecipe.data.title) {
        this.viewRecipe = null;
      } else {
        this.viewRecipe = recipe;
        this.modal = "recipe-view";
      }
    },
    closeRecipeView() {
      this.modal = null;
      this.viewRecipe = null;
    },
  },
}
</script>
